import { format, parseISO } from 'date-fns';
import { zonedTimeToUtc, utcToZonedTime } from 'date-fns-tz';

export const TIMEZONE = 'America/Denver';

// Convert a date to UTC for storage
export function toUTC(date: string | Date | null): string | null {
  if (!date) return null;
  const localDate = typeof date === 'string' ? parseISO(date) : date;
  return zonedTimeToUtc(localDate, TIMEZONE).toISOString();
}

// Convert a UTC date to local time for display
export function toLocal(utcDate: string | null): string | null {
  if (!utcDate) return null;
  const date = utcToZonedTime(utcDate, TIMEZONE);
  return format(date, 'yyyy-MM-dd');
}

// Format a date for display with time
export function formatDateTime(date: string | null): string {
  if (!date) return '';
  const localDate = utcToZonedTime(date, TIMEZONE);
  return format(localDate, 'PPp');
}

// Format a date for display without time
export function formatDate(date: string | null): string {
  if (!date) return '';
  const localDate = utcToZonedTime(date, TIMEZONE);
  return format(localDate, 'PP');
}